import React, { useState, useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import {
  CircularProgress,
  FormControl,
  IconButton,
  Typography,
} from "@material-ui/core";
import useStyles from "../../assets/styles/styles";
import "../DialogActivities/modalactivities.css";
import CustomButton from "../../controls/Button/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomizedInputs from "../../controls/InputCustom/CustomizedInputs";
import { showMessageModal, validate } from "../../utils/utilsFunctions";
import {  registerUser } from "../../redux/actions/registerUsersActions";
import { useResizeScreen } from "../../hooks/useResizeScreen";

const ModalRegisterProfileMedico = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { title, description, observation, info, open, onClose, modalconfirm, crossDarkColor,
    functionConfirm, itemConfirm, modalLogout, buttonType, handleClick, empty, customClass, modalRegister, customBackgroundDialog, customBackgroundDialogContent, loading, ...other } = props;

  const [enrollment, setEnrollment] = useState("");
  const [credential, setCredential] = useState("");
  const [type, setType] = useState("");
  const [birthDate, setbirthDate] = useState(new Date());
  const [dni, setDni] = useState("");
  const { screen } = useResizeScreen();
  const userTypeValidation = useSelector((state) => state.registerUsersReducer.userTypeValidation);
  const [errorMessageModal, setErrorMessageModal] = useState(false);
  const personalDataReducer = useSelector(state => state.personalDataReducer);
  const errorMessage = useSelector((state) => state.registerUsersReducer.msgError);
  const registerReduxState = useSelector((state) => state.registerUsersReducer);

  const campoObligatorio = "*Campo obligatorio";

  const [aditionalDataErrors, setAditionalDataErrors] = useState({
    credential:
      userTypeValidation?.perfil?.trim() == "AFILIADO" ||
        userTypeValidation?.perfil?.trim() == "AFILIADO-MEDICO"
        ? campoObligatorio
        : "",
  });

  const isAditionalDataValidForm = () =>
    Object.values(aditionalDataErrors).every((x) => x === "");


    useEffect(() => {
        if (personalDataReducer?.fullData?.afiliado?.documentos != undefined) {
            setType(personalDataReducer?.fullData?.afiliado?.documentos?.[0]?.documentoTipoCodigo)
            setDni(personalDataReducer?.fullData?.afiliado?.documentos?.[0]?.documentoNumero)
            setbirthDate(personalDataReducer?.fullData?.afiliado?.fechaNacimiento)
        }

    }, [personalDataReducer?.fullData?.afiliado?.documentos])


    useEffect(() => {
        if (errorMessage?.length > 0) {
            setErrorMessageModal(true);
        }
    }, [errorMessage]);


    useEffect(() => {
        if (registerReduxState?.registerUser?.confirmacion) {
          window.location.replace("/");
        }
      }, [registerReduxState?.registerUser?.confirmacion]);


    useEffect(() => {

        const dateOfBirth = window.localStorage.getItem("dateOfBirth");
        const documentType = window.localStorage.getItem("documentType");
        const dni = window.localStorage.getItem("dni");


        if (dateOfBirth && documentType && dni) {
            setbirthDate(dateOfBirth);
            setType(documentType);
            setDni(dni);
        }
    }, []);




    const validateOnlyNumbers = (credentialNumber) => {
        return credentialNumber?.match(/^\d*$/);
    };


    const closeModal = () => {
        setErrorMessageModal(false);
    };


    const loguinEnrollment = () => {
        const showRedire = (errorMessage?.length > 0)

        if (isAditionalDataValidForm()) {

            const email = window.localStorage.getItem("email");

            let perfilSeleccionado = "AFILIADO";

            let request = {
                mail: email,
                tipoRegistracion: perfilSeleccionado,
                telefono: "",
                tipoDocumento: type,
                nroDocumento: dni,
                nroCredencial: credential,
                fechaNacimiento: birthDate,
                matricula: enrollment,
            };

            dispatch(registerUser(request));
        }
    };


  const handleChangeCredential = (e) => {
    e.preventDefault();
    setCredential(e.target.value);
  };

  const handleOnBlurCredential = () => {
    validate(
      "credential",
      campoObligatorio,
      credential,
      setAditionalDataErrors,
      aditionalDataErrors
    );
    credential?.length > 40 &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        credential: "*El campo debe tener como máximo 40 caracteres",
      });
    !validateOnlyNumbers(credential) &&
      setAditionalDataErrors({
        ...aditionalDataErrors,
        credential: "*El campo debe tener sólo números",
      });
  };


  const handleClose = () => {
    onClose(false);
  };


  const confirm = () => {
    functionConfirm(itemConfirm);
    onClose(false);
  };

  const renderEnrollmentInput = () => {
    return (
      <>
        <FormControl className={` ${classes.inputLoginProfile} `} variant="standard" style={{ marginTop: "-145px",marginRight:"-150px",margin:"center" }}>
          <CustomizedInputs
            name="credential"
            label={<span style={{ color: 'white',fontSize:"15px", marginLeft: screen.sWidth < 768 ? "80px":"110px" }}>NUMERO DE CREDENCIAL</span>}  
            value={credential}
            onChange={handleChangeCredential}
            onBlur={handleOnBlurCredential}
          />
        </FormControl>
      </>
    );
  };

  const buttonNotConfirm = () => {
    return modalRegister ?
      <CustomButton
        title="NO"
        className={classes.buttonNotConfirmModal}
        onClick={handleClick}
      /> :
      <CustomButton
        title="NO"
        className={classes.buttonNotConfirmModal}
        onClick={handleClose}
      />;
  };



  const modalLogoutFunction = () => {
    let jsxBtn = (
      <CustomButton
        title="SI"
        className={`${classes.buttonConfirmModal} ${classes.lightLinearGradient}`}
        onClick={confirm}
      />);
    if (modalLogout) {
      jsxBtn = (
        <CustomButton
          title="SI"
          className={`${classes.buttonConfirmModal} ${classes.lightLinearGradient}`}
          onClick={loguinEnrollment}
          disabled={!isAditionalDataValidForm()}

        />
      );
    } else if (buttonType === 'submit') {
      jsxBtn = (
        <CustomButton
          title="SI"
          className={`${classes.buttonConfirmModal} ${classes.lightLinearGradient}`}
          type={buttonType}
          onClick={handleClick}
        />
      );
    }
    else if (modalRegister) {
      jsxBtn = (
        <CustomButton
          title="SI"
          className={`${classes.buttonConfirmModal} ${classes.lightLinearGradient}`}
          type={buttonType}
          onClick={handleClose}
        />
      );
    }

    return jsxBtn;
  };

  const bodyModal = () => {
    const DEFAULT = (
      <>
      </>
    );
    const BODY = {
      'modalconfirm': (
        <div style={{ textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", marginTop:"10px" }}>
          {renderEnrollmentInput()}
          {showMessageModal(errorMessage, errorMessageModal, setErrorMessageModal, classes.borderWhite, classes.quickAccessIcon,  classes.contentDialogTitle, closeModal)}
          {modalLogoutFunction()}
          {buttonNotConfirm()}
        </div>
      ),
      'empty': ''
    };
    let response = DEFAULT;
    if (modalconfirm)
      response = BODY['modalconfirm'];
    else if (empty)
      response = BODY['empty'];

    return response;
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        id="backDropActivities"
        {...other}
      >
        <div id="modalActivities">
          {!modalRegister &&
            <IconButton
              aria-label="close"
              className={crossDarkColor ? classes.closeActivitiesButton : classes.closeButton}
              onClick={handleClose}
            >
              <CloseIcon />
            </IconButton>
          }

          <DialogTitle
            id="customized-dialog-title"
            className={`${classes.contentDialogModalRegisterProfile} ${customClass} ${customBackgroundDialog}`}
            style={{ textAlign: "center" }}
            onClose={handleClose}
          >
            <Typography className={classes.titleDialogActivities} style={{ fontWeight: "600" }}>
              {title}
            </Typography>
          </DialogTitle>

          <DialogContent className={`${classes.contentDialogModalRegisterProfile} ${customClass} ${customBackgroundDialogContent}`} style={{ paddingTop: "10px" }}>
            <Typography style={{ paddingBottom: "20px" }}>
              {
                loading ? (
                  <div className={`${classes.boxPointsDrawer} ${classes.centeredBox} ${classes.whiteCircularProgress}`}>
                    <CircularProgress />
                  </div>
                ) : description
              }
            </Typography>
            <Typography style={{ paddingBottom: "20px" }}>
              {observation}
            </Typography>
            {bodyModal()}
          </DialogContent>

        </div>
      </Dialog>
    </>
  );
};
export default ModalRegisterProfileMedico;
